import axios from 'axios';

import { API } from '@/config/constants';


const getReport = async (path, params) => {
  const response = await axios.get(`${API}/reports/${path}`, { params });
  return response.data;
};


export const getRevenueReport = (params) => getReport('revenue', params);

export const getOrdersBySourceReport = (params) => (
  getReport('orders-by-source', params)
);


export const getGrossBySourceReport = (params) => (
  getReport('gross-by-source', params)
);

export const getNetBySourceReport = (params) => (
  getReport('net-by-source', params)
);

export const getOrdersBySubsourceReport = (params) => (
  getReport('orders-by-subsource', params)
);

export const getPipelineReport = (params) => getReport('pipeline', params);
